export enum ApplicationFormSchemaStepFields {
  TYPE = 'type',
  ALERT = 'alert',
  FIELDS = 'fields',
  IS_SKIP_BY_CHECKED = 'is_skip_by_checked',
  IS_SKIP_BY_UNCHECKED = 'is_skip_by_unchecked',
}
